const actions = {
  SET_SUMMARY_DATA: 'veriglif/SET_SUMMARY_DATA',
  DELETE_SUMMARY_DATA: 'veriglif/DELETE_SUMMARY_DATA',
  SET_STATE: 'veriglif/SET_STATE',
  SEND_CODE: 'veriglif/SEND_CODE',
  RESET_STATE: 'veriglif/RESET_STATE',
}

export default actions
